import React from 'react';
import { ArrowRight, CloudSun, Snowflake, Map } from 'lucide-react';

export const Hero: React.FC = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Your Adventure
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              Starts Here
            </span>
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Roam is your collection of essential apps for outdoor enthusiasts. 
            From weather forecasts to snow conditions, we provide the tools you need 
            for unforgettable adventures.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <a 
              href="https://weather.roamapps.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-medium flex items-center gap-2 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Try Roam Weather
              <ArrowRight className="h-5 w-5" />
            </a>
            
            <a 
              href="#apps"
              className="border-2 border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 px-8 py-4 rounded-xl font-medium transition-colors"
            >
              Explore All Apps
            </a>
          </div>

          {/* Feature icons */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-gray-200">
              <div className="bg-blue-100 p-3 rounded-full mb-4">
                <CloudSun className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Weather Forecasts</h3>
              <p className="text-gray-600 text-center">Multi-day forecasts for multiple locations at once</p>
            </div>

            <div className="flex flex-col items-center p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-gray-200">
              <div className="bg-indigo-100 p-3 rounded-full mb-4">
                <Snowflake className="h-8 w-8 text-indigo-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Snow Forecasts</h3>
              <p className="text-gray-600 text-center">Coming soon - Cumulative snow forecasts for powder hunting</p>
            </div>

            <div className="flex flex-col items-center p-6 bg-white/60 backdrop-blur-sm rounded-2xl border border-gray-200">
              <div className="bg-purple-100 p-3 rounded-full mb-4">
                <Map className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Trail Maps</h3>
              <p className="text-gray-600 text-center">Coming soon - Detailed maps for hiking and climbing</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
